import { WOD_ADD_KNOWN_WORD_FAILED, WOD_ADD_KNOWN_WORD_SUCCEEDED, GET_WORD_PACKET, IS_WEB_TOKEN_VALID, SIGN_IN, SIGN_OUT, WORD_ARRAY_ADD_KNOWN_WORD_FAILED, WORD_ARRAY_ADD_KNOWN_WORD_SUCCEEDED, ADD_WORD_TO_LEARN, CHECK_RETURNS_TO_TEST, RETURN_TEST_REPORTED_SUCCESSFULLY, IS_FETCHING_USER, USER_FETCHED, ADD_OWN_WORD, FLAG_WORD_ASSET, SKIP_WORD_FROM_WORD_PACKET, FETCH_SYSTEM_METRICS, GET_WORD_BANK, GET_LEADER_BOARD, REMOVE_IGNORED_WORD, REMOVE_FROM_CURRENT_3 } from "./types"
import { AxiosAuth, AxiosWordAPI } from "../api";
import history from "../components/history";



//%                             Auth Actions                                    //
//#region Auth Actions///
export const signIn = (userInfo) => async dispatch => {



    const userAndToken = await AxiosAuth.post('/login', userInfo, { withCredentials: true });
    await dispatch({ type: SIGN_IN, payload: userAndToken.data });
    history.push('/dashBoard');


}




export const signUp = (userInfo) => async dispatch => {
    try {
        const user = await AxiosAuth.post("/register", userInfo);
        if (user) {
            dispatch(signIn(userInfo));
        }
    } catch (err) {
        console.log(err.message);
        console.log(err);
    }
}


export const signOut = () => async dispatch => {
    await AxiosAuth.get("/logOut");
    dispatch({ type: SIGN_OUT });
    history.push('/');


}
export const isFetchingUser = () => {
    return { type: IS_FETCHING_USER }

}

export const userFetched = () => {
    return { type: USER_FETCHED };
}


export const isWebTokenValid = (token) => async dispatch => {
    try {
        await dispatch(isFetchingUser());
        const tokenRes = await AxiosAuth.post("/tokenIsValid", null, { headers: { "x-auth-token": token } });

        await dispatch({
            type: IS_WEB_TOKEN_VALID,
            payload: tokenRes.data
        });
        if (tokenRes.data.isSignedIn) {
        } else {
            dispatch(signOut());
        }

    } catch (err) {
        dispatch(signOut());
    }

    await dispatch(userFetched());

}

//#endregion 

//%                                           SYSTEM ACTIONS                                                //
export const fetchSystemMetrics = () => async dispatch => {
    let token = localStorage.getItem('auth-token');


    const response = await AxiosWordAPI.get('/fetchSystemMetrics', { headers: { 'x-auth-token': token } });

    if (!response) {

    } else {
        dispatch({ type: FETCH_SYSTEM_METRICS, payload: response.data })
    }


}



//$                                           Word Actions                                                       //

export const getUserWordBank = () => async dispatch => {
    let token = localStorage.getItem('auth-token');

    try {
        const wordBankResponse = await AxiosWordAPI.get('/getUserWordBank', { headers: { 'x-auth-token': token } });

        dispatch(
            {
                type: GET_WORD_BANK,
                payload: wordBankResponse.data
            }
        )
    } catch (err) {
        console.log(err);
    }
}

export const removeIgnoredWord = (word) => async dispatch => {
    let token = localStorage.getItem("auth-token");
    const removedIgnoredWordResponse = await AxiosWordAPI.post('/removeIgnoredWord', { word }, { headers: { "x-auth-token": token } });
    dispatch({
        type: REMOVE_IGNORED_WORD,
        payload: removedIgnoredWordResponse.data
    })
}
export const removeFromCurrent3 = (word) => async dispatch => {
    let token = localStorage.getItem("auth-token");
    const removedFromCurrent3Response = await AxiosWordAPI.post('/removeFromCurrent3', { word }, { headers: { "x-auth-token": token } });
    dispatch({
        type: REMOVE_FROM_CURRENT_3,
        payload: removedFromCurrent3Response.data
    })
}


export const getWordPacket = () => async dispatch => {
    let token = localStorage.getItem("auth-token");
    const wordPacketResponse = await AxiosWordAPI.get('/getWordPacket', { headers: { "x-auth-token": token } });

    dispatch(
        {
            type: GET_WORD_PACKET,
            payload: wordPacketResponse.data
        }
    )

}

export const getLeaderBoard = () => async dispatch => {
    let token = localStorage.getItem("auth-token");
    try {
        const leaderBoardResponse = await AxiosWordAPI.get('/getLeaderBoard', { headers: { "x-auth-token": token } });
        dispatch(
            {
                type: GET_LEADER_BOARD,
                payload: leaderBoardResponse.data
            }
        )
    } catch (err) {
        console.log(err)
    }


}

export const addWODKnownWord = (wordId) => async dispatch => {

    try {
        let token = localStorage.getItem("auth-token");
        const wordAddedSuccessfully = await AxiosWordAPI.post('/addKnownWord', { wordId }, { headers: { "x-auth-token": token } });
        if (wordAddedSuccessfully) {
            dispatch({ type: WOD_ADD_KNOWN_WORD_SUCCEEDED })
        }
    } catch (error) {
        dispatch({ type: WOD_ADD_KNOWN_WORD_FAILED })
    }
}

export const addWordPacketToKnownWords = (wordId) => async dispatch => {
    try {
        let token = localStorage.getItem("auth-token");
        const wordAddedSuccessfully = await AxiosWordAPI.post('/addKnownWord', { wordId }, { headers: { "x-auth-token": token } });
        if (wordAddedSuccessfully) {
            await dispatch({ type: WORD_ARRAY_ADD_KNOWN_WORD_SUCCEEDED });
        }

    } catch (error) {
        dispatch({ type: WORD_ARRAY_ADD_KNOWN_WORD_FAILED })
        console.log(error.response);
    }

}

export const skipWordFromWordPacket = () => {
    return { type: SKIP_WORD_FROM_WORD_PACKET }


}

export const addWordToLearn = (wordId) => async dispatch => {
    try {
        let token = localStorage.getItem("auth-token");
        const wordAddedSuccessfully = await AxiosWordAPI.post('/addWordToLearn', { wordId }, { headers: { "x-auth-token": token } });
        if (wordAddedSuccessfully) {
            dispatch({ type: ADD_WORD_TO_LEARN, payload: wordAddedSuccessfully.data });
        }

    } catch (error) {
        console.log(error.response);
    }
}


export const checkForReturnTests = () => async dispatch => {
    try {
        let token = localStorage.getItem("auth-token");
        const words = await AxiosWordAPI.get('/checkForReturnTests', { headers: { "x-auth-token": token } });
        dispatch({ type: CHECK_RETURNS_TO_TEST, payload: words.data });


    } catch (error) {
        console.log(error.response);
    }


}

export const giveReturnsTestResult = (word, isCorrect) => async dispatch => {

    try {
        let token = localStorage.getItem("auth-token");
        const response = await AxiosWordAPI.post('/returnSubmitted', { word, isCorrect }, { headers: { "x-auth-token": token } });
        dispatch({ type: RETURN_TEST_REPORTED_SUCCESSFULLY, payload: response.data });

    } catch (error) {
        console.log(error);
    }

}

export const addOwnWord = (wordToAdd) => async dispatch => {
    //error is caught in script
    let token = localStorage.getItem('auth-token');
    const response = await AxiosWordAPI.post('/addOwnWord', { wordToAdd }, { headers: { 'x-auth-token': token } });
    dispatch({ type: ADD_OWN_WORD, payload: response.data });

}

export const flagWordAsset = (wordToFlag, message) => async dispatch => {


    let token = localStorage.getItem('auth-token');
    try {
        await AxiosWordAPI.post('/flagWordAsset', { word: wordToFlag, message: message }, { headers: { 'x-auth-token': token } });
        dispatch({ type: FLAG_WORD_ASSET, payload: { word: wordToFlag } })
    } catch (err) {
        console.log(err);
    }

}


////#endregion